/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

/**
 * Directive that handles the transcoding progress of an audio or video block on an editing page.
 */
angular.module('bulbApp.contentEditorModule')

  .directive('transcodingAsset', ['$interval', '$timeout', 'Restangular', 'CONTENT_EDITOR', transcodingAsset]);

function transcodingAsset($interval, $timeout, Restangular, CONTENT_EDITOR) {
  return {
    restrict: 'E',
    require: '^contentBlock',
    link: function link(scope, element, attrs, contentBlockCtrl) {
      const currentBlockType = contentBlockCtrl.contentBlock.blockType;
      let statusCheck;

      scope.progress = 0;
      scope.blockType = currentBlockType;
      scope.status = (currentBlockType === 'AUDIO') ? 'transcoding_audio_init' : 'transcoding_video_init';
      scope.allowRefresh = false;

      // Method to get JWPlayer video content block.
      function getJWPlayerVideoContentBlock() {
        return document.querySelector(`#content-block-${contentBlockCtrl.contentBlock.id}`);
      }

      // Helper method to check whether the video is in idle mode, means user has not played the video.
      function isVideoIdle() {
        const jwPlayerContentBlock = getJWPlayerVideoContentBlock();
        return (!jwPlayerContentBlock || !jwPlayerContentBlock.querySelector('video')
          || jwPlayerContentBlock.classList.contains('jw-state-idle')
          || jwPlayerContentBlock.classList.contains('jw-error')
        );
      }

      /**
       * Function for toggling instant video player placeholder text.
       * @returns {boolean}
       */
      scope.showPlaceholderText = () => scope.status === 'transcoding_video_init'
          || !getJWPlayerVideoContentBlock()?.querySelector('video');

      /**
       * Function for manually refreshing the video content block.
       */
      scope.refresh = () => {
        contentBlockCtrl.refetchContentBlock();
      };

      // Ping the server for the status of the video transcoding
      function checkAssetStatus() {
        Restangular.one('units', contentBlockCtrl.page.unit.id)
          .one(CONTENT_EDITOR.BLOCK_PATHS[currentBlockType], (currentBlockType === 'VIDEO')
            ? contentBlockCtrl.contentBlock.video.id // jshint ignore:line
            : contentBlockCtrl.contentBlock.audio.id)
          .customGET('status').then((response) => {
            // if the progress is -1, it means the progress unknown.  Ignore the progress update in this
            // case until we we have a way of displaying indeterminate progress.  FUTURE
            if (response.percentComplete !== -1) {
              scope.progress = response.percentComplete;
            }
            scope.status = response.statusCode;
            // Only need for video uploads
            if (currentBlockType === 'VIDEO' && response.splashImage) {
              scope.splashImageUrl = response.splashImageHref;
            }

            if (response.complete) {
              if (statusCheck) {
                $interval.cancel(statusCheck);
              }
              if (isVideoIdle()) {
                contentBlockCtrl.refetchContentBlock();
              } else {
                scope.allowRefresh = true;
              }
            }
          });
      }

      // Do initial, immediate status check:
      checkAssetStatus();

      // Keep checking the status until the transcoding has completed
      statusCheck = $interval(checkAssetStatus, 3000);

      // Make sure the interval is destroyed when the element is destroyed, otherwise it will continue to run
      element.on('$destroy', () => {
        $interval.cancel(statusCheck);
      });
    },
    templateUrl: 'ajs/components/contenteditor/transcodingasset.html',
  };
}
